import React from 'react';

import useDraggable from '../hooks/useDraggable';

interface IGantLeftHeaderHookDraggable {
    gridGantRef: React.RefObject<HTMLDivElement>;
    headerLeftGantRef: React.RefObject<HTMLDivElement>;
}

const GantLeftHeaderHookDraggable: React.FC<IGantLeftHeaderHookDraggable> = ({ gridGantRef, headerLeftGantRef }) => {
    useDraggable(gridGantRef, headerLeftGantRef);

    return null;
};

export default GantLeftHeaderHookDraggable;
